import { createContext } from 'react';

interface FloatingContextValue {
  appendElement: (elementId: string) => void;
  removeElement: (elementId: string) => void;
  setScrollLockTarget: (el: HTMLElement | null) => void;
}

export const FloatingContext = createContext<FloatingContextValue>({} as FloatingContextValue);
